export const ModalStates = {
  CLOSED: 'closed',
  DELETE: 'delete',
  ENABLE_ALL: 'enableAll',
  DISABLE_ALL: 'disableAll',
  TOGGLE_CHANGE: 'toggleChange',
};
